import { Breadcrumb } from 'antd';
import classnames from 'classnames';
import { isObject } from 'lodash';
import { connect } from 'react-redux';
import { hasCurrentUser as hasCurrentUserSelector } from '@store/selectors';
import { NavLink } from 'react-router-dom';
import { StoreState } from '@root/types';
import s from './Breadcrumbs.module.less';

const mapState = (state: StoreState) => ({
  crumbs: state.ui.breadcrumbs,
  hasCurrentUser: hasCurrentUserSelector(state),
});

type StateProps = ReturnType<typeof mapState>;

type PassedProps = {
  className?: string;
};

function RawBreadcrumbs({ crumbs, className, hasCurrentUser }: StateProps & PassedProps) {
  if (!hasCurrentUser) return null;

  return (
    <Breadcrumb
      data-testid="breadcrumbs"
      className={classnames(s.breadcrumbs, className)}
      separator=""
    >
      {crumbs.map((crumb, i) => {
        const isLastCrumb = i === crumbs.length - 1;
        const breadcrumbClass = classnames(s.breadcrumb, isLastCrumb ? s.lastBreadcrumb : '');
        const breadcrumb = isObject(crumb) ? (
          <Breadcrumb.Item key={crumb.content} prefixCls={breadcrumbClass} data-testid="breadcrumb">
            <NavLink
              to={crumb.link ?? ''}
              className={classnames(s.link, s.breadcrumb)}
              onClick={() => crumb.onClick && crumb.onClick()}
            >
              {crumb.content}
            </NavLink>
          </Breadcrumb.Item>
        ) : (
          <Breadcrumb.Item key={crumb} prefixCls={breadcrumbClass} data-testid="breadcrumb">
            {crumb}
          </Breadcrumb.Item>
        );
        const separator = !isLastCrumb ? (
          <Breadcrumb.Separator>
            {/* eslint-disable-next-line react/jsx-no-literals */}
            <span className={s.separator}>/</span>
          </Breadcrumb.Separator>
        ) : (
          <></>
        );

        return [breadcrumb, separator];
      })}
    </Breadcrumb>
  );
}

export { RawBreadcrumbs };
export default connect(mapState)(RawBreadcrumbs);
